<div class="g-slider-container">
  <div @fadeInOut *ngIf="cert$ | async as cert">
    <div class="g-field-area">
      <label for="certificateTextarea">{{ dialogTexts.field }}</label>
      <textarea id="certificateTextarea" class="g-large-field" readonly>{{ cert }}</textarea>
    </div>

    <app-ui-button-copy [textToCopy]="cert" [showLabel]="true"></app-ui-button-copy>

  </div>
</div>
